// A horizontal scanning beam that drifts left → right across the heatmap
// row stack while the AI is working — implies continuous evaluation. The
// keyframe is defined in auto-formulate.css.
export function ScanBeam() {
  return (
    <div className="af-scan" aria-hidden="true">
      <div className="af-scan-bar" />
    </div>
  );
}
